/**
 * O endereço de um chamado, para copiar e mandar a alguém.
 *
 * ## Por que isto existe
 *
 * Item 6 do Daniel (28/10/2026): "ao registrar uma ação, criar o ticket e já
 * apresentar o número, permitindo copiar/compartilhar o link". O número já
 * aparecia no aviso de criação; o que faltava era o link.
 *
 * ## Por que o endereço sai de `window.location`
 *
 * Porque o AloDesk é white-label: cada empresa abre o sistema por um endereço
 * diferente. Uma constante aqui -- ou a URL da api -- daria um link que abre
 * no lugar errado para todo mundo que não for a SysFar, e daria **em
 * silêncio**: quem copiou só descobre quando o outro lado reclama que não
 * abre. O mesmo raciocínio do link público da central de ajuda, que é montado
 * pelo servidor justamente para não existir em dois lugares.
 *
 * ## O caminho é o mesmo que a tela usa
 *
 * `/ticket/:id`, e **id**, não o `number`: é a rota real do sistema. O número
 * que se MOSTRA é outro (`numerosDoChamado`), e trocar um pelo outro aqui
 * faria o link abrir um chamado diferente -- ou nenhum.
 */

/**
 * @param {number|string} id  a chave do chamado (`tickets.id`)
 * @param {object} [onde]     a origem; o padrão é a janela atual
 * @returns {string} o endereço completo, ou `''` quando não há id
 */
export const linkDoChamado = (id, onde = (typeof window !== 'undefined' ? window.location : null)) => {
    const chave = id === null || id === undefined ? '' : String(id).trim();

    if (!chave) return '';

    const origem = onde && onde.origin ? String(onde.origin).replace(/\/+$/, '') : '';

    // Sem origem (teste sem janela, navegador antigo sem `origin`) devolve o
    // caminho relativo em vez de `undefined/ticket/1`: ele ainda serve para
    // colar na barra de endereços do próprio sistema.
    return `${origem}/ticket/${chave}`;
};

export default linkDoChamado;
